import { useCallback } from 'react'
import { useActivitySummaryContext } from '../../../context'
import { openActivitySummaryActionCreator as open } from '../../../state'

export function useHandlers() {
  const [, dispatch] = useActivitySummaryContext()

  const onClick = useCallback(() => dispatch(open()), [dispatch])

  return { onClick }
}
